module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a1f80f9b899dc988e41.worker.js");
};